<template>
	<div
		class="flex h-full overflow-y-auto bg-gray-100 reverse"
		:class="orientationClasses"
	>
		<aside
			class="w-full h-full max-w-sm p-6 overflow-y-auto bg-white shadow-md"
			:class="borderClasses"
		>
			<slot name="sidebar"></slot>
		</aside>
		<main class="grow h-full p-6 overflow-y-scroll quick-nav-content">
			<slot></slot>
		</main>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	orientation?: "left" | "right";
}
const props = withDefaults(defineProps<Props>(), {
	orientation: "right",
});
const orientationClasses = computed(() => ({
	"flex-row-reverse": props.orientation == "right",
}));
const borderClasses = computed(() => ({
	"border-l": props.orientation == "right",
	"border-r": props.orientation == "left",
}));
</script>
